export { EloTextAlignRightIcon } from './text-align-right-icon'
